import { getUserProfile, setSwipeBack } from '@/utils/nativeBridge.js'
import store from '@/store'
import Utils from '../utils/utils'

function setStore (data) {
  store.session = data.session
  store.uin = data.uin
  store.mmaclientid = data.clientid
  store.rndkey = data.rndkey
  store.prdlocation = data.prdlocation
  store.clientType = data.clientType
  store.mobileArea = data.mobile_area
  store.mobile = data.mobile
  // 以下为v1.7新增的字段，详情可见connect-docs
  store.curClientId = data.curClientId
  store.curAccountId = data.curAccountId
  store.curClientType = data.curClientType
  store.curAcctid = data.curAcctid
  if (String(store.prdlocation) === '0') {
    store.region = 'HK'
  } else if (String(store.prdlocation) === '1') {
    store.region = 'MO'
  }
}

setSwipeBack('1') // 开启右滑返回

export default function (needShare) {
  return new Promise(resolve => {
    if (needShare && Utils.getUrlQuery().isShare) {
      // 在app外打开的页面
      resolve('')
    } else {
      getUserProfile().then(data => {
        setStore(data)
        resolve('')
      })
    }
  })
}
